import { render, staticRenderFns } from "./BuyComplete.vue?vue&type=template&id=f00ed170&"
import script from "./BuyComplete.vue?vue&type=script&lang=js&"
export * from "./BuyComplete.vue?vue&type=script&lang=js&"
import style0 from "./BuyComplete.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports